import { parentAttributeAddUrl, ParentAttributeListUrlSortField } from "@dashboard/parentAttributes/urls";
import { TopNav } from "@dashboard/components/AppLayout/TopNav";
import { DashboardCard } from "@dashboard/components/Card";
import { FilterPresetsSelect } from "@dashboard/components/FilterPresetsSelect";
import { configurationMenuUrl } from "@dashboard/configuration";
import useNavigator from "@dashboard/hooks/useNavigator";
import { sectionNames } from "@dashboard/intl";
import { Box, Button, ChevronRightIcon } from "@saleor/macaw-ui-next";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { FilterPagePropsWithPresets, PageListProps, SortPage } from "../../../types";
import { ParentAttributeListDatagrid } from "../ParentAttributeListDatagrid";
import { ParentAttribute } from "../../types";

export interface ParentAttributeListPageProps
  extends PageListProps,
    FilterPagePropsWithPresets<string, any>,
    SortPage<ParentAttributeListUrlSortField> {
  parentAttributes: ParentAttribute[];
  selectedParentAttributeIds: string[];
  onParentAttributesDelete: () => void;
  onSelectParentAttributeIds: (rows: number[], clearSelection: () => void) => void;
}

const ParentAttributeListPage = ({
  filterOpts,
  initialSearch,
  onFilterChange,
  onSearchChange,
  hasPresetsChanged,
  onFilterPresetChange,
  onFilterPresetDelete,
  onFilterPresetPresetSave,
  onFilterPresetUpdate,
  onFilterPresetsAll,
  filterPresets,
  selectedFilterPreset,
  onParentAttributesDelete,
  selectedParentAttributeIds,
  ...listProps
}: ParentAttributeListPageProps) => {
  const intl = useIntl();
  const navigate = useNavigator();
  const [isFilterPresetOpen, setFilterPresetOpen] = useState(false);

  return (
    <>
      <TopNav
        href={configurationMenuUrl}
        title={intl.formatMessage(sectionNames.parentAttributes)}
        withoutBorder
        isAlignToRight={false}
      >
        <Box __flex={1} display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex">
            <Box marginX={3} display="flex" alignItems="center">
              <ChevronRightIcon />
            </Box>

            <FilterPresetsSelect
              presetsChanged={hasPresetsChanged()}
              onSelect={onFilterPresetChange}
              onRemove={onFilterPresetDelete}
              onUpdate={onFilterPresetUpdate}
              savedPresets={filterPresets}
              activePreset={selectedFilterPreset}
              onSelectAll={onFilterPresetsAll}
              onSave={onFilterPresetPresetSave}
              isOpen={isFilterPresetOpen}
              onOpenChange={setFilterPresetOpen}
              selectAllLabel={intl.formatMessage({
                id: "parentAttributesAll",
                defaultMessage: "All parent attributes",
                description: "tab name",
              })}
            />
          </Box>
          <Box>
            <Button
              onClick={() => navigate(parentAttributeAddUrl())}
              variant="primary"
              data-test-id="create-parent-attribute-button"
            >
              <FormattedMessage
                id="createParentAttribute"
                defaultMessage="Create parent attribute"
                description="button"
              />
            </Button>
          </Box>
        </Box>
      </TopNav>
      <DashboardCard>
        <ParentAttributeListDatagrid {...listProps} />
      </DashboardCard>
    </>
  );
};

ParentAttributeListPage.displayName = "ParentAttributeListPage";
export default ParentAttributeListPage;